'use strict';

require('regenerator-runtime/runtime');

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');



window.NodeList.prototype.forEach = Array.prototype.forEach

window.Node.prototype.contains = function contains(node) {
	if (!(0 in arguments)) {
		throw new TypeError('1 argument is required')
	}

	while (node = node && node.parentNode){
		if (this === node) {
			return true
		}
  }

	return false
};

if (!("classList" in SVGElement.prototype)) {
  Object.defineProperty(SVGElement.prototype, "classList", {
    get: function () {
      return {
        contains: function (className) {
          return this.className && this.className.baseVal.split(" ").indexOf(className) !== -1;
        }
      };
    }
  });
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 714
// module chunks = 0